import React from "react";
import UscVehicleInformation from "./common/UscVehicleInformation";
import { useUscSelector } from "../../../../redux/store";
import { UscNavStepEnum } from "../../../../utils/constants";
import { UscLabel } from "../../../../utils/labels";
import * as Styles from "./UscBasket.styles";
import Icon from "../../../../../shared-components/lexus/styles/atoms/Icon";
import { UscTrackingLocation } from "../../../../utils/tracking";
import BasketVehicleCode from "./common/BasketVehicleCode";
import { useComponentRegistry } from "../../componentRegistry";

// !! Note that this component has a "Loading" version as well: UscLoadingBasket.
const UscBasket = (): JSX.Element | null => {
    const enablePreviousNextCars = useUscSelector((state) => state.uscSettings.enablePreviousNextCars);
    const step = useUscSelector((state) => state.nav.step);
    const result = useUscSelector((state) => state.vehicle.result);

    const UscBasketCtas = useComponentRegistry("UscBasketCtas");
    const UscQrCode = useComponentRegistry("UscQrCode");

    if (!result) return null;

    return (
        <Styles.Wrapper>
            <Styles.Top>
                <Styles.VehicleInformationDesktopWrapper>
                    <UscVehicleInformation trackingLocation={UscTrackingLocation.Basket} />
                </Styles.VehicleInformationDesktopWrapper>
                <UscBasketCtas trackingLocation={UscTrackingLocation.Basket} />
                <UscQrCode />
            </Styles.Top>
            <Styles.Bottom>
                {step === UscNavStepEnum.Pdp && (
                    <>
                        {/* TODO: Implement Previous/Next Ctas - UC-43 */}
                        {enablePreviousNextCars && (
                            <Styles.ButtonWrapper>
                                <Styles.Button type="button">
                                    <Icon variant="chevron-left" />
                                    <UscLabel label="uscBasketPreviousCarCta" />
                                </Styles.Button>
                                <Styles.Button type="button" iconRight>
                                    <Icon variant="chevron-right" />
                                    <UscLabel label="uscBasketNextCarCta" />
                                </Styles.Button>
                            </Styles.ButtonWrapper>
                        )}
                    </>
                )}

                <BasketVehicleCode />
            </Styles.Bottom>
        </Styles.Wrapper>
    );
};

export default UscBasket;
